<template>
  <div id="app">
    <div v-if="!isMobile">
      <!-- 置顶 -->
      <el-backtop :visibility-height="100" :bottom="100" v-if="!isMobile">
        <div class="go-top-box" style="{width: 51px;}">
          <div class="top" style="{width: 100%;height: 51px;background: #BECEDF;text-align: center;}">
            <i class="icon iconfont icon-zhiding" style="{font-size: 36px;color: #fff;line-height: 51px;}"></i>
          </div>
        </div>
      </el-backtop>
      <HeaderComponentP class="head-com"></HeaderComponentP>
      <div class="view-box">
        <router-view/>
      </div>
      <FooterComponentP></FooterComponentP>
      <!-- 二维码登录提示 -->
        <div class="pc-qrcode-box" v-show="qrcodeShow">
            <i class="icon iconfont icon-shanchu2" @click="qrcodeShow = false"></i>
            <div id="wxLoginBoxPc"></div>
        </div>
    </div>
    <div v-if="isMobile" style="height:100%">
      <!-- 置顶 -->
      <el-backtop :visibility-height="100" :bottom="100" :right="20" v-if="isMobile && !appGoTopHidden">
        <div class="app-gotop">
          <div class="app-top">
            <i class="icon iconfont icon-zhiding2"></i>
          </div>
        </div>
      </el-backtop>
      <HeaderComponentM class="mobile-header" v-if="!headerShow"></HeaderComponentM>
      <div class="mobile-view-box" :class="{goods:headerShow}">
        <router-view/>
      </div>
      <!-- 弹窗提示 -->
      <div class="popupbox" v-show="operationTipsShow">{{operationTipsTxt}}</div>
      <!-- <LoginM v-if="isMobile&&!isLogin&&!headerShow"></LoginM> -->
    </div>
    <el-dialog custom-class="follow-dialog-box" :visible.sync="followVisible" width="667px">
      <p class="follow-dialog-title">
        添加至
        <span>（需要选择一个时间戳才可以关注）</span>
      </p>
      <div class="follow-times-box">
        <div class="time-item" v-for="(item, i) in hourFolders" :key="i" :class="{active:timerIndex==item.id}" 
          @click="handleTimerItem(item.id)">{{item.name}}</div>
      </div>
      <p class="new-title">新增</p>
      <div class="new-timer-box">
        <el-time-select v-model="timerValue" :picker-options="{ start: '00:00', step: '00:30', end: '23:30' }" 
          placeholder="选择时间" :editable="false" @change="handleTimer()">
        </el-time-select>
        <el-button type="primary" size="mini" style="margin-left:10px;background:#215A92;" 
          @click="addFolderTime()" v-show="newTimerFlag">确定</el-button>
      </div>
      <div class="follow-btn-box">
        <el-button type="primary" size="small" style="background:#215A92;" @click="sureFollow()">确定</el-button>
        <el-button size="small" @click="cancelFollow()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      qrcodeShow: false,
      // 关注弹窗
      followVisible: false,
      // 24小时文件夹列表
      hourFolders: [],
      // 时间选中项
      timerIndex: 0,
      // 新增时间值
      timerValue: '',
      // 新增时间确定按钮控制
      newTimerFlag: false,
      // 关注弹窗按钮控制
      // followBtnsFlag: false,
      operationTipsTxt: '', // 移动端操作提示语
      operationTipsShow: false, // 移动端操作提示语控制
      appGoTopHidden: false, // 移动端回到顶部功能隐藏
      testToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvYXBpLmJpZ2JheXMuY25cL2FwaVwvdXNlclwvd3hsb2dpbiIsImlhdCI6MTYxMjE4MDk3OSwiZXhwIjoxNjEyMjY3Mzc5LCJuYmYiOjE2MTIxODA5NzksImp0aSI6ImR0UmRFMUpXbXJOdVo3NnciLCJzdWIiOjQxLCJwcnYiOiI0Y2U3NDg3NGQ2YjNkNmMxOTZhMzQyNWZiZWU0N2Q5NGU3YWRhZjcwIiwicm9sZSI6InVzZXJzIn0.c26ZvnUwxtH1ruuVFOQQcHJuak1lbw4bLdV5Zt8JKlk'
    }
  },
  computed: {
    // 是否为移动端判断
    isMobile() {
      return this.$store.state.isMobile;
    },
    // 是否登录
    isLogin() {
      return this.$store.state.isLogin;
    },
    // 移动端头部显示控制
    headerShow() {
      return this.$store.state.headerShow;
    },
    // 当前栏目id
    nowColumnId() {
      return this.$store.state.nowColumnParams.columnId;
    }
  },
  created() {
    // window.localStorage.setItem('token', this.testToken);
    // window.localStorage.clear();
    this.beforeOpenDispose();
    this.openBus();
    this.getColumnList();
  },
  mounted() {
    this.getEquipment();
  },
  methods: {
    /**
     * @function openBus 开启监听
     */
    openBus() {
      this.Bus.$on('haveToken', res => {
        if(res) {
          window.localStorage.setItem('token', '');
          this.$store.commit('setLoginStatus', false);
          this.isWeixin();
        }
      });
      this.Bus.$on('followColumn', res => {
        this.followVisible = res;
        this.getHourFolders();
      });
      // 监听操作提示语显示
      this.Bus.$on('operationtips', str => {
        this.operationTipsTxt = str;
        this.operationTipsShow = true;
        setTimeout(() => {
          this.operationTipsShow = false;
        }, 1500);
      });
      // 移动端回到顶部功能隐藏
      this.Bus.$on('appGoTopHidden', res => {
        this.appGoTopHidden = res;
      });
      // 登录提示二维码弹窗
      this.Bus.$on('loginTips', res=> {
        if(res) {
          this.qrcodeShow = true;
          this.getWxLoginConfig();
        }
      });
    },
    /**
     * @function getColumnList 获取栏目列表
     */
    getColumnList() {
      this.$axios.get(this.Urls.columnList).then(res => {
        let list = res.data.result;
        this.$store.commit('setColumnList', list);
      });
    },
    /**
     * @function getEquipment 获取设备信息是否为移动端
     */
    getEquipment() {
      if(this.isMobile) {
        this.setRemSize();
      }
    },
    /**
     * @function setRemSize 设置rem比例
     */
    setRemSize() {
      // 设计稿宽度414px
      let w = 375;
      // 根元素fontsize尺寸
      let html = document.documentElement;
      // let size = window.getComputedStyle(html).fontSize;
      // 获取屏幕宽度
      let scrWidth = document.documentElement.clientWidth;
      let rem = 100;
      // (当前设备屏幕宽度 / 设计稿宽度) * 当前1rem的取值
      html.style.fontSize = ((scrWidth / w) * rem) + 'px';
      let dpr = window.devicePixelRatio;
      html.setAttribute('data-dpr', dpr);
      html = null;
    },
    /**
     * @function beforeOpenDispose 打开网址前的处理
     */
    beforeOpenDispose() {
      if(window.localStorage.getItem('token')) {
        this.$store.dispatch('getUserInfo', null); // 获取用户信息
      }
    },
    /**
     * @function isWeixin 判断是否在微信端
     */
    isWeixin() {
      var ua = navigator.userAgent.toLowerCase();
      let iswx = ua.indexOf('micromessenger') != -1, 
          isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);;
      window.sessionStorage.setItem('isweixin', JSON.stringify({iswx: iswx}));
      if(iswx && isMobile) {
        // 如果在微信端，调起微信登录授权页
        let path = String(this.$route.fullPath).substr(1);
        window.location.href = `https://api.bigbays.cn/api/user/userinfo?type=3&targeturl=${path}`;
      }
    },
    /**
     * @function getWxLoginConfig 获取微信登录信息
     */
    getWxLoginConfig() {
        let flag = document.body.clientWidth > 500;
        if(flag) {
            this.$axios.get(this.Urls.wxLogin).then(res => {
                let info = res.data.result;
                const codeInfo = new WxLogin({
                    self_redirect: false,
                    id: "wxLoginBoxPc", 
                    appid: info.app_id, 
                    scope: info.scope, 
                    redirect_uri: info.redirect_uri,
                    state: info.state,
                    style: "",
                    href: ""
                });
            });
        }
    },
    /**
     * @function getHourFolders 获取24小时文件夹列表
     */
    getHourFolders() {
      this.$axios.get(this.Urls.timerFolderList).then(res => {
        this.hourFolders = res.data.result.data;
      });
    },
    /**
     * @function handleTimerItem 选择时间选项
     */
    handleTimerItem(id) {
      this.timerIndex = this.timerIndex == id ? 0 : id;
      // this.followBtnsFlag = this.timerIndex > 0;
    },
    /**
     * @function handleTimer 选择时间
     */
    handleTimer() {
      if(this.timerValue) {
        this.newTimerFlag = true;
      } else {
        this.newTimerFlag = false;
      }
    },
    /**
     * @function addFolderTime 添加时间文件夹
     */
    addFolderTime() {
      this.$axios.post(this.Urls.newTimerFolder, { name: this.timerValue }).then(res => {
        if(res.data.status == 200) {
          this.timerValue = '';
          this.newTimerFlag = false;
          this.getHourFolders();
        }
      });
    },
    /**
     * @function sureFollow 确定关注
     */
    sureFollow() {
      let sendData = {
        column_id: this.nowColumnId,
        daydynamic_id: this.timerIndex
      };
      this.$axios.post(this.Urls.followColumn, sendData).then(res => {
        if(res.data.status == 200) {
          this.cancelFollow();
          // this.getColumnList();
          let item = {
              columnId: this.nowColumnId,
              columnName: this.$store.state.nowColumnParams.columnName,
              columnInfo: this.$store.state.nowColumnParams.columnInfo,
              qrcode: this.$store.state.nowColumnParams.qrcode,
              isfollow: true
          };
          this.$store.commit('setNowColumnParams', item);
          this.Bus.$emit('followResult', true);
        } else {
          this.Bus.$emit('followResult', false);
        }
      });
    },
    /**
     * @function cancelFollow 取消关注，关闭弹窗
     */
    cancelFollow() {
      this.followVisible = this.newTimerFlag = false;
      this.timerIndex = 0;
      this.timerValue = '';
    }
  }
}
</script>

<style lang="scss">
#app {
  position: relative;
  width: 100%;
  // height: 100%;
  font-family: PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  letter-spacing: .7px;
  -webkit-font-smoothing: antialiased;
  -webkit-appearance: none;
  -moz-osx-font-smoothing: grayscale;
  background: #F4F7F9;
  overflow: auto;
  .popupbox {
    position: fixed;
    top: 50%;
    left: 50%;
    padding: 0.12rem 0.2rem;
    border-radius: 0.04rem;
    background: rgba(0, 0, 0, .5);
    transform: translate(-50%, -50%);
    font-size: 0.14rem;
    color: #f2f2f2;
  }
}
.head-com {
  position: relative;
  /* position: fixed; */
  z-index: 999;
}
.view-box {
  /* padding-top: 217px; */
  min-height: 600px;
}
.mobile-header {
  position: fixed;
  z-index: 999;
}
.mobile-view-box {
  position: relative;
  height: calc(100% - 0.6rem);
  padding-top: 0.6rem;
}
.goods {
  height: 100%;
  padding: 0;
}
.app-gotop-box {
  position: fixed;
  bottom: 1rem;
  right: 0.16rem;
  width: 0.45rem;
  height: 0.45rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 0.06rem rgba(0, 0, 0, .16);
  text-align: center;
  line-height: 0.45rem;
  overflow: hidden;
  .icon-zhiding2 {
    font-size: 0.26rem;
    color: #999;
  }
}
.go-top-box {
  position: fixed;
  bottom: 100px;
  right: 40px;
  width: 51px;
}
.top {
  width: 100%;
  height: 51px;
  background: #BECEDF;
  text-align: center;
}
.app-top {
  width: 0.45rem;
  height: 0.45rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 0.06rem rgba(0, 0, 0, .16);
  text-align: center;
  overflow: hidden;
  .icon-zhiding2 {
    font-size: 0.26rem;
    color: #999;
    line-height: 0.45rem;
  }
}
.top > i {
  font-size: 36px;
  color: #fff;
  line-height: 51px;
}
.follow-dialog-box {
  height: 620px;
  .el-dialog__header, .el-dialog__body {
    padding: 0;
  }
  .follow-dialog-title {
    padding: 20px 0 23px 28px;
    font-size: 16px;
    color: #071829;
    > span {
      font-size: 14px;
      color: #999;
    }
  }
  .follow-times-box {
    display: flex;
    flex-wrap: wrap;
    width: calc(100% - 37px);
    min-height: 150px;
    padding: 0 18.5px;
    .time-item {
      width: 57px;
      height: 34px;
      margin: 0 16.5px 20px;
      background: #D7DEE6;
      border-radius: 4px;
      font-size: 14px;
      color: #071829;
      text-align: center;
      line-height: 34px;
      cursor: pointer;
    }
    .active {
      width: 55px;
      height: 32px;
      line-height: 32px;
      border: 1px solid #215A92;
    }
  }
  .new-title {
    padding: 30px 0 17px 36px;
    font-size: 16px;
    color: #071829;
  }
  .new-timer-box {
    display: flex;
    align-items: center;
    padding: 0 0 0 36px;
  }
  .follow-btn-box {
    margin-top: 116px;
    text-align: center;
  }
}
.pc-qrcode-box {
        position: fixed;
        top: 50%;
        left: 50%;
        padding: 20px;
        transform: translate(-50%, -50%);
        background: #fff;
        border: 1px solid #eee;
        box-shadow: 0 0 5px #999;
        .icon-shanchu2 {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
        }
    }
@media screen and(max-width: 500px) {
  .el-message-box__wrapper {
    .el-message-box {
      width: 64% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue